import { notification } from "antd";
import axiosRetry from "axios-retry";
import { refreshToken } from "helpers";

import { NEW_HOST_URL } from "../../../config/envConfig";
import { logoutUser } from "../../../containers/app/utils";
import LocalStorage from "../../../utils/LocalStorage";
import APIService from "../index";

const magnifiAPIInstance = APIService({
  baseURL: NEW_HOST_URL,
});

magnifiAPIInstance.interceptors.request.use((config) => {
  if (!config?.skipAuthHeader) {
    config.headers["Authorization"] = LocalStorage.getItem("authToken");
  }

  return config;
});

magnifiAPIInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 && !error?.config?.skipAuthHeader) {
      logoutUser();
    }
    throw error;
  },
);

magnifiAPIInstance.interceptors.response.use(
  async function (res) {
    const response = res?.response;
    if (response?.status === 403) {
      const newToken = await refreshToken();
      if (!newToken) {
        LocalStorage.removeItem("authToken");
        LocalStorage.removeItem("__uid");
        notification["info"]({ message: "Session Expired !! Please login again.." });
        setTimeout(() => {
          window.location.pathname = "/login";
        }, 1000);
      }
      LocalStorage.setItem("authToken", newToken);
      response.config.headers["Authorization"] = `${newToken}`;

      return magnifiAPIInstance.request(response.config);
    } else if (response?.status === 419) {
      LocalStorage.removeItem("authToken");
      LocalStorage.removeItem("__uid");
      notification["info"]({ message: "Session Expired !! Please login again.." });
      setTimeout(() => {
        window.location.pathname = "/login";
      }, 1000);
    }

    return res;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Configure axios-retry
axiosRetry(magnifiAPIInstance, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  shouldResetTimeout: true,
  retryCondition: (error) => {
    return error?.response?.status === 504;
  },
});

export default magnifiAPIInstance;
